module.exports = __webpack_public_path__ + "img/0Q3A0072_L_WoodMatted_MockedUp.f8ea340c.jpg";